import {SharedInputEdit} from '../../components/SharedInputEdit';
import {SharedSelect} from "../../components/SharedSelect";
import { CalculatorAdvancedMode } from '../../../../shared/classes/CalculatorMode';
import { useContext } from 'react';
import { CalculatorAdvancedModeContext } from '../../../../shared/contexts/CalculatorContext';

export function OperationsInput(): JSX.Element {
    const advancedMode = useContext(CalculatorAdvancedModeContext)!;

    return (
        <div className="operations --ctow">

            <div>

                <div>

                    <h4>Data Inputs from Imaging Department</h4>

                    <SharedInputEdit inputName='facility_opening_in_hours'/>
                    <SharedInputEdit inputName='facility_opening_in_days_per_year'/>
                    <SharedInputEdit inputName='percent_of_exams_rescheduled_after_an_event'/>
                    <SharedInputEdit inputName='admin_fee_per_rescheduled_patient'/>
                    <SharedSelect inputName="product_line"/>

                    <SharedSelect inputName='rate_HTM_org_performance'/>

                </div>

                {
                    advancedMode[0] === CalculatorAdvancedMode.Advanced
                        ? <div>

                            <h4>Data Inputs for Surgery Dpt Impact</h4>

                            <SharedInputEdit inputName='surgery_avg_surgery_lenght_in_hours'/>
                            <SharedInputEdit inputName='surgery_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery'/>
                            <SharedInputEdit inputName='surgery_avg_cost_per_hour_in_the_intensive_care_dept'/>

                        </div>
                        : ''
                }

            </div>

        </div>

    );
}
